// extracted by mini-css-extract-plugin
export var wrapper = "Etc-module--wrapper--8kiF5";
export var item = "Etc-module--item--2jns2";
export var innerGrid = "Etc-module--innerGrid--3rh5z";
export var imgbox = "Etc-module--imgbox--OWHJR";
export var text = "Etc-module--text--2aM3x";